import { Fragment } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Typography } from '../../../molecules/Typography';
import { Colors, IMaterial } from '../../../../models/disciplines';
import ContentCard from '../../ContentCard';
import formatFileCategory from '../../../../commom/formatFileCategory';
import { IExercise } from '../../../../models/exercise';
import { useFreemiumLock } from '../../FreemiumLockModal/useFreemiumLock';
import { getUniversitarioDisciplinePermission } from '../../../../utils/discipline';

interface ExercisesContentSectionProps {
  title: string;
  linkTo: string;
  showLink: boolean;
  children: React.ReactNode;
}

function ExercisesContentSection({
  title,
  linkTo,
  showLink,
  children,
}: ExercisesContentSectionProps) {
  return (
    <div className='xs:basis-full lg:basis-1/3'>
      <div className='mb-4 flex flex-row items-end justify-between'>
        <Typography
          type='titleSection'
          size='h5'
          className='text-mono-color-dark'
        >
          {title}
        </Typography>
        {showLink && (
          <Link to={linkTo} className='text-sm text-color-brand-primary'>
            Ver mais
          </Link>
        )}
      </div>
      <div className='flex flex-col gap-md'>{children}</div>
    </div>
  );
}

interface ExercisesContentProps {
  discipline: string;
  module?: string;
  data: any;
  isPending: boolean;
  onFavoriteCallback?: (data: any) => void;
  onDone?: (id: string, slug: string) => void;
}

const ExercisesContent = ({ discipline, module, data, onFavoriteCallback, onDone }: ExercisesContentProps) => {
  const navigate = useNavigate();
  const { isLocked, isUnlocked, openLock } = useFreemiumLock();
  const isUniversitario = !!getUniversitarioDisciplinePermission(discipline);
  return (
    <Fragment>
      <ExercisesContentSection
        title='EXERCÍCIOS'
        linkTo={`/disciplinas/${discipline}/modulo/${module}/tipo/exercicio`}
        showLink={data?.exercise.length === 2}
      >
        {data?.exercise.map((it: IExercise, i: number) => {
          const locked = isLocked(it);
          return (
          <ContentCard
            color={discipline as Colors}
            key={it.id || i}
            title={isUniversitario ? undefined : it.title}
            done={it.done}
            favorite={it.favorite}
            icon='edit'
            content='exercise'
            action={() =>
              locked
                ? openLock()
                : navigate(
                    `/disciplinas/${discipline}/modulo/${module}/assunto/${it.subjects[0].slug}/exercicio/${it.slug}`
                  )
            }
            subject={it.subjects[0].title}
            id={it.id}
            slug={it.slug}
            hasCallback={!!onFavoriteCallback}
            callback={onFavoriteCallback}
            onDone={onDone}
            locked={locked}
            freemiumUnlocked={isUnlocked(it)}
          >
            <Typography
              size='small'
              className='transition delay-100 ease-in-out group-hover:text-card-color-default'
            >
              {it.statement}
            </Typography>
          </ContentCard>
          );
        })}
      </ExercisesContentSection>
    </Fragment>
  );
};

export default ExercisesContent;
